export function isInputSeqAcked(seq: number, ackSeq: number): boolean {
  return ((ackSeq - seq + 0x10000) & 0xFFFF) < 0x8000
}

export function consumeAckedInputSentTimes(
  inputSentAt: Map<number, number>,
  ackSeq: number,
): number | undefined {
  let latestAckedSentAt: number | undefined
  let latestAckedDistance = 0x10000

  for (const [seq, sentAt] of inputSentAt) {
    if (!isInputSeqAcked(seq, ackSeq)) continue
    const distance = (ackSeq - seq + 0x10000) & 0xFFFF
    if (distance < latestAckedDistance) {
      latestAckedDistance = distance
      latestAckedSentAt = sentAt
    }
    inputSentAt.delete(seq)
  }

  return latestAckedSentAt
}
